import React, {FC, PropsWithChildren, useEffect, useState} from 'react';
import {SideBar, Footer, WelcomeStep} from '../Components';
import {WizardStepEnum} from '../types';
import {Flex, Scrollbar, Title} from '@priority-software/priority-style-react';
import styles from './StepFactory.module.scss';
import {useSideBarContext} from '../hooks';
import texts from '../texts';
import {useScrollWrapDimensions} from '../../../hooks/customScroll/useScrollWrapDimensions';

const ComponentWrapper: FC<PropsWithChildren> = ({children}) => {
    const {maxHeight, setWrapRef} = useScrollWrapDimensions();

    const [height, setHeight] = useState(0);

    useEffect(() => {
        const updateWindowDimensions = () => {
            const newHeight = window.innerHeight;
            setHeight(newHeight);
        };

        window.addEventListener('resize', updateWindowDimensions);

        updateWindowDimensions();

        return () => window.removeEventListener('resize', updateWindowDimensions);
    }, []);

    return height > 740 ? (
        <>{children}</>
    ) : (
        <div ref={setWrapRef} className={styles.scrollWrapper}>
            <Scrollbar autoHeight autoHeightMax={maxHeight - 72}>
                {children}
            </Scrollbar>
        </div>
    );
};

export const StepFactory: FC = () => {
    const {currentStep} = useSideBarContext();

    return currentStep.type === WizardStepEnum.Welcome ? (
        <WelcomeStep />
    ) : (
        <Flex direction={'row'} componentClasses={styles.wrapper}>
            <SideBar />
            <Flex
                direction={'column'}
                componentClasses={styles.innerWrapper}
                justifyContent={'space-between'}
                alignItems={'flex-start'}
            >
                <div className={styles.contentWrapper}>
                    {currentStep.type !== WizardStepEnum.Finished && (
                        <Title
                            skin={'h2'}
                            textColor={'primary-500'}
                            componentClasses={styles.stepTitle}
                        >
                            {texts[currentStep.name]}
                        </Title>
                    )}
                    <ComponentWrapper>
                        <currentStep.component />
                    </ComponentWrapper>
                </div>
                <Footer />
            </Flex>
        </Flex>
    );
};
